import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

function CheckYourEmail() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        maxWidth: "80vw",
        mx: "auto",
      }}
    >
      <Typography variant="h4" component="h1">
        {t("Η εγγραφή σας ολοκληρώθηκε με επιτυχία")}
      </Typography>
      <Typography variant="h6" component="h2">
        {t("Καλωσήρθατε στο σύστημα. Θα πρέπει τώρα να ελέγξετε το e-mail")}{" "}
        {location?.state?.userEmail}{" "}
        {t(
          "σας και να πατήσετε τον ειδικό σύνδεσμο ενεργοποίησης λογαριασμού που περιλαμβάνει.",
        )}{" "}
        {t("To email θα σταλεί τα επόμενα λεπτά")}
      </Typography>
      <Button
        sx={{ alignSelf: "center" }}
        variant="contained"
        onClick={() => {
          navigate("/welcome/loginForm");
        }}
      >
        {t("Μετάβαση στην οθόνη εισόδου")}
      </Button>
    </Box>
  );
}

export default CheckYourEmail;
